
export const formatEuro = (value: number) => {
    var formatter = new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
    });

    return formatter.format(value)
}
